import { ReactNode } from 'react';
import { Dialog } from 'components/Dialog';

interface Props {
  text: string | ReactNode;
  title?: string;
  onYes: () => void;
  onNo: () => void;
  /**
   * Which is the primary action (the one that appears on the right bottom of the modal)?
   * Default: Y */
  primaryAction?: 'Y' | 'N';
  yesLabel?: string;
  noLabel?: string;
}

export const ConfirmationModal = ({
  text, onYes, onNo, title, primaryAction = 'Y', yesLabel, noLabel,
}: Props) => (
  <Dialog>
    <div className="p-6">
      <div className="relative">
        <h1 className="text-lg font-semibold text-orange">{title || 'Confirm'}</h1>
      </div>
      <div className="py-4">
        {text}
      </div>
      <div className="flex justify-end gap-3">
        {(primaryAction === 'Y')
          ? (
            <>
              <button type="button" className="btn-primary-outlined" onClick={onNo}>
                {noLabel || 'No'}
              </button>
              <button type="button" className="btn-primary" onClick={onYes}>
                {yesLabel || 'Yes'}
              </button>
            </>
          )
          : (
            <>
              <button type="button" className="btn-primary" onClick={onNo}>
                {noLabel || 'No'}
              </button>
              <button type="button" className="btn-primary-outlined" onClick={onYes}>
                {yesLabel || 'Yes'}
              </button>
            </>
          )}
      </div>
    </div>
  </Dialog>
);
